
import {
  computed, defineComponent, onMounted, ref,
} from 'vue';
import draggable from 'vuedraggable';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { useMainStore } from '@/store/mainStore';
import { ICaseFileOrder, IMedia, IMediaExtended } from '@/types/interfaces';
import AppHeader from '@/components/AppHeader.vue';
import ItemPhoto from '@/modules/drive/components/items/ItemPhoto.vue';
import DriveService from '@/modules/drive/services/DriveService';

export default defineComponent({
  components: { draggable, ItemPhoto, AppHeader },
  setup(props, context) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const drag = ref(false);
    const items = ref<IMedia[]>([]);
    const caseName = computed(() => driveStore.currentCase.title);
    const dataUpdate = ref(false);
    const dragOptions = ref({
      animation: 200,
      delay: 40,
      disabled: false,
      ghostClass: 'ghost',
    });

    const noChanges = computed(() => JSON.stringify(items.value) === JSON.stringify(driveStore.currentCase.photos));

    function startDrag() {
      drag.value = true;
    }

    function updateFilesOrder(data: ICaseFileOrder) {
      // block that update and sort photos in driveStore.currentCase
      driveStore.currentCase.photos.forEach((el) => {
        if (data.order !== null) {
          // eslint-disable-next-line no-param-reassign
          (el as IMediaExtended).order = data.order[el.id];
        }
      });
      driveStore.currentCase.photos.sort((a, b) => (a as IMediaExtended).order - (b as IMediaExtended).order);
    }

    async function onDone() {
      if (driveStore.currentCase.id === null) return;
      dataUpdate.value = true;
      const payload: ICaseFileOrder = {
        caseId: driveStore.currentCase.id,
        order: null,
      };

      const preset = items.value.map((el, idx) => ({ key: el.id, value: idx }));
      const itemsOrder = new Map();

      preset.forEach((obj) => { itemsOrder.set(obj.key, obj.value); });
      payload.order = Object.fromEntries(itemsOrder);

      const response = await DriveService.setFilesOrder(payload);
      if (response.success) {
        updateFilesOrder(payload);
        context.emit('close');
      } else {
        dataUpdate.value = false;
      }
    }

    onMounted(() => {
      items.value = JSON.parse(JSON.stringify(driveStore.currentCase.photos));
    });
    return {
      noChanges,
      dataUpdate,
      drag,
      items,
      caseName,
      dragOptions,
      startDrag,
      onDone,
      mainStore,
    };
  },
});
